/**
 * Created by quikr on 8/26/16.
 */
import React, {Component} from "react";
import {Field, reduxForm} from "redux-form";
import AutoComplete from "material-ui/AutoComplete";
import axios from "axios";
import Checkbox from "material-ui/Checkbox";
import Button from "react-bootstrap/lib/Button";
import {DatePicker, TextField} from "redux-form-material-ui";


let employees = new Array();
let actualEmployees;

let min = new Date();
min.setDate(min.getDate() - 2);
let max = new Date();
max.setDate(max.getDate() - 1);
const renderField = (props) => (
  <input  {...props} />
);
let from = new Date();
from.setDate(from.getDate() - 7);
let to = new Date();
var default_search = {
  startDate: from,
  endDate: to
};

const Comments = (() => {
  return (
    <TextField
      hintText="Enter comments if any"
      multiLine={true}
      rows={2}
      rowsMax={4}/>
  );
});


class Form extends Component {
  constructor() {
    super();
    this.state = {error: "", request_object: default_search, index: -1, empId: -1};
    this.handleChange = this.handleChange.bind(this);
    this.changeEmpId = this.changeEmpId.bind(this);
  }

  handleChange(date) {
    this.setState({
      startDate: date

    });
  }

  changeEmpId(id) {
    this.setState({empId: id})
  }

  componentDidMount() {


    axios.get(process.env.REQ_URL + '/myEmployee', {
      url: '',
      method: 'get',
      params: {},
      data: {},
      withCredentials: true,
      contentType: 'application/json',
      responseType: 'json',
    }).then((response)=> {
      console.log(response.data);
      actualEmployees = response.data.data;
      response.data.data.map((node, index)=> {
        employees[index] = node.empId.toString() + ' ' + node.empName;

      })
      console.log(employees);
    }).catch((error)=> {

    });


    // on TextField
  }

  render() {


    const {handleSubmit, pristine, reset, submitting} = this.props;
    const formStyle = {
      padding: '0px'
    };


    return (
      <div style={{formStyle}}>
        <form onSubmit={handleSubmit(data => {


          console.log("request to be sent");
          console.log(data);
          if (data.startDate > data.endDate) {

            this.setState({error: "Check the Dates"});
            return;
          }
          else {
            let request = new Object();
            request.startDate = data.startDate ? data.startDate : this.props.dates.startDate;
            request.endDate = data.endDate ? data.endDate : this.props.dates.endDate;
            this.props.changeDate(request);


            this.props.formSubmit(request);
            this.setState({error: "", request_object: request});
          }

        })}>

        <div className = "col-md-8">
          <div className = "row">
            <div className="col-md-4">
              <img src="/public/images/calendar.png" style={{paddingRight: '10'}}/>

              <Field name="startDate"
                   container="inline"
                   autoOk={true}
                   component={DatePicker}
                   style={{display: 'inline'}}
                   defaultValue={this.props.dates.startDate}

                   mode={'portrait'}
                   textFieldStyle={{width: '70%'}}

                   maxDate={new Date()}
                   formatDate={(date)=> {
                     console.log(date);
                     return (date.toString().substring(0, 16));
                   }}
              // DatePicker requires an object,
              // and redux-form defaults to ''
                   floatingLabelText="Start Date"
                   hintText="Start Date "/>

            </div>
            <div className="col-md-4" style={{paddingRight: 0}}>

              <img src="/public/images/calendarO.png" style={{paddingRight: '10'}}/>
              <Field name="endDate"
                   autoOk={true}
                   container="inline"
                   style={{display: 'inline'}}
                   component={DatePicker}
                   defaultValue={this.props.dates.endDate}
                   floatingLabelText="End Date"
                   textFieldStyle={{width: '70%'}}
                   mode={'portrait'}
                   maxDate={new Date()}

                   formatDate={(date)=> {
                     console.log(date);
                     return (date.toString().substring(0, 16));
                   }}

              // and redux-form defaults to ''
                   hintText="End Date "/>
            </div>
          </div>
          <div className = "row" style={{display: 'inline'}}>
            <div className="col-md-2" style={{paddingLeft: 0}}>
              <Checkbox
                style={{paddingLeft: '0px', paddingTop: '35px', height: '30px', paddingBottom: 0, width: '40px'}}
                inputStyle={{height: '30px'}}
                iconStyle={{fill: '#5cb85c'}}
                labelStyle={{fontSize: '15px'}}
                checked={this.props.indirect}
                label="Indirect"
                onCheck={()=> {
                  this.props.changeDirect();
                }}/>
            </div>
            {(this.props.isVertical) ?

            <div className="col-md-2" style={{paddingLeft: 0}}>
                     <Checkbox
                        style={{paddingLeft: '0px', paddingTop: '35px', height: '30px', paddingBottom: 0, width: '40px'}}
                        inputStyle={{height: '30px'}}
                        iconStyle={{fill: '#5cb85c'}}
                        labelStyle={{fontSize: '15px'}}
                        checked={this.props.vertical}
                        label="Vertical"
                        onCheck={()=> {
                          this.props.changeView();
                        }}/>
            </div> : null}
            <div className="col-md-2" style={{paddingLeft: 0 , display: this.props.employeeCode == '1766' || this.props.employeeCode == '189' ? 'inline' : 'none'}}>
                <Checkbox
                  style={{paddingLeft: '0px', paddingTop: '35px', height: '30px', paddingBottom: 0, width: '40px'}}
                  inputStyle={{height: '30px'}}
                  iconStyle={{fill: '#5cb85c'}}
                  labelStyle={{fontSize: '15px'}}
                  checked={this.props.functionHead}
                  label="Function"
                  onCheck={()=> {
                    this.props.changeFunctionHead();
                  }}/>
            </div>
         </div>
        </div>
        <div className = "col-md-4" style={{'paddingTop': '5px'}}>
          <div style={{'textAlign': 'left', 'display': 'inline', 'padding': 0, 'marginLeft': '0'}}>
            <div className = "col-md-2" style={{'margin': '2% 0px 0% 0px', 'paddingLeft': '0'}}>
                <div>
                    <Button
                     backgroundColor="#008bcf"
                     className="btn btn-default btn-lg"
                     style={{width: '100px', marginLeft: '5px'}}
                     onClick={()=> {
                     handleSubmit((data)=> {
                       console.log("am i doing it right?");
                       console.log(data);
                     })
                     }}
                     type="submit"
                     disabled={false}> Search
                     <img src="/public/images/magnifying-glass.png"
                         style={{'paddingLeft': '6px'}}
                     />
                     </Button> {this.state.error.length == 0 ? <label></label> :
                        <label style={{color: 'red', paddingLeft: '5px'}}>Check the dates</label>}
                </div>
            </div>
            <div className = "col-md-2" style={{'margin': '2% 0px 0%' ,'paddingLeft': '60px'}}>
                <div>
                     <Button
                        className="btn btn-default btn-lg"
                        style={{marginTop: '10%'}}
                        type="button"
                        onClick={this.props.downloadExcel}
                     >Download Excel </Button>
                </div>
            </div>
          </div>
        </div>


        </form>

      </div>
    )
  }
}

export default reduxForm({
  form: 'TeamSearch',

})(Form)






/** WEBPACK FOOTER **
 ** ./src/feature/attendance/TeamAttendance/TeamSearch.js
 **/